import React from 'react'
import createClass from 'create-react-class'
import Config, { TYPE } from './interface/Config';
import i18n from 'live/services/i18n'
import Instance from './interface/Instance';
import Select from 'react-select'
// from '@intelie/live/dist/src/services/i18n';
var FormBase = require('live/components/extensions/ui/form');

var FormGroup = require('live/components/forms/ui/form-group')



const ValidationMixin = require('live/components/forms/mixins/validation-mixin'),
    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
        type: TYPE,
        active: true,
        config: {
            user: '',
            password: '',
            host: '',
            directory: '',
            pathPrivateKey: '',
            port: 22,
            strictHostKeyChecking: true,
            alwaysDeleteFile: true,
            usePrivateKey: false,
            cron: '* * * * *',
            filterExtensions: []
        },
        fullQualifier: null,
        qualifier: null,
        status: {}
    } as Config
    );



export default createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id;
    },
    _onDelete: function () {
        window.location.href = '#/integrations/';
    },
    onChangeFilterExtensions: function (servers) {
        var object = this.state.object,
            config = object.config;

        config.filterExtensions = servers;
        this.applyObj({ config: config });
    },
    onChangeCheckbox: function (e) {
        var object = this.state.object,
            config = object.config,
            field = e.target.name;

        config[field] = !config[field];
        this.applyObj({ config: config });
    },
    render: function () {
        const object = this.state.object
        const config = object.config || {}

        const {
            alwaysDeleteFile = false,
            directory = '',
            host = '',
            password = '',
            pathPrivateKey = '',
            port = 22,
            strictHostKeyChecking = false,
            usePrivateKey = false,
            user = '',
            cron = '* * * * *',
            filterExtensions = []
        } = config as Instance

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <FormGroup type="text" label={<span> {i18n('User name')}<abbr title="required">*</abbr></span>}
                        name="config.user" value={user}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.user')}
                        hasFeedback help={this.errorsFor('config.user')} />

                    <FormGroup type="text" label={<span> {i18n('Password')}<abbr title="required">*</abbr></span>}
                        name="config.password" value={password}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.password')}
                        hasFeedback help={this.errorsFor('config.password')} />

                    <FormGroup type="text" label={<span> {i18n('Host')}<abbr title="required">*</abbr></span>}
                        name="config.host" value={host}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.host')}
                        hasFeedback help={this.errorsFor('config.host')} />

                    <FormGroup type="number" label={<span> {i18n('Port')}<abbr title="required">*</abbr></span>}
                        name="config.port" value={port}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.port')}
                        hasFeedback help={this.errorsFor('config.port')} />


                    <FormGroup type="text" label={<span> {i18n('Directory')}<abbr title="required">*</abbr></span>}
                        name="config.directory" value={directory}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.directory')}
                        hasFeedback help={this.errorsFor('config.directory')} />

                    <FormGroup type="text" label={<span> {i18n('Cron')}<abbr title="required">*</abbr></span>}
                        name="config.cron" value={cron}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.cron')}
                        hasFeedback help={this.errorsFor('config.cron')} />
                    <div className="form-group">
                        <label className="checkbox">
                            <input type="checkbox"
                                name="alwaysDeleteFile"
                                disabled={false}
                                checked={alwaysDeleteFile}
                                onChange={this.onChangeCheckbox} />
                            {i18n('Aways delete file')}
                        </label>
                    </div>
                    <div className="form-group">
                        <label className="checkbox">
                            <input type="checkbox"
                                name="strictHostKeyChecking"
                                checked={strictHostKeyChecking}
                                onChange={this.onChangeCheckbox} />
                            {i18n('strict Host Key Checking')}
                        </label>
                    </div>
                    <div className="form-group">
                        <label className="checkbox">
                            <input type="checkbox"
                                name="usePrivateKey"
                                checked={usePrivateKey}
                                onChange={this.onChangeCheckbox} />
                            {i18n('Use private key')}
                        </label>
                    </div>
                    <FormGroup type="text" disabled={!usePrivateKey} label={<span> {i18n('Path private key')}<abbr title="required">*</abbr></span>}
                        name="config.pathPrivateKey" value={pathPrivateKey}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.pathPrivateKey')}
                        hasFeedback help={this.errorsFor('config.pathPrivateKey')} />
                    <div className='form-group'>
                        <div><label>Filter extensions</label></div>
                        <Select.Creatable
                            value={[...filterExtensions].map(value => ({ label: value, value }))}
                            options={[...filterExtensions].map(value => ({ label: value, value }))}
                            isMult={true}
                            multi={true}
                            onChange={(actions, options) => {                                
                                this.onChangeFilterExtensions(
                                    [...actions]
                                        .map(({ value }) => value)
                                        .filter(v => !!v)
                                        .map(v => String(v).toLowerCase()
                                        )

                                )


                            }} />
                    </div>

                </div>
            </FormBase>
        );
    }
});
